import { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../../../../context/AuthContext';
import { API_BASE_URL } from '../../../../../Helpers/apiConfig';

const useSubjectName = () => {
    const { user } = useAuth();
    const params = useParams();
    const [subjectName, setSubjectName] = useState("");

    useEffect(() => {
        const getSubject = async () => {
            try {
                const headerss = {
                    accept: "*/*",
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Credentials': 'false',
                    Authorization: 'Bearer ' + user.token
                };
                const url = `${API_BASE_URL}/user/Content/GetSubject`;
                const res = await axios.get(url, {
                    headers: headerss,
                    params: { courseId: params.courseid }
                });
                if (res.data.success) {
                    setSubjectName(
                        res.data.data.subjects[params.subjectid - 1].subjectName +
                        " - " +
                        res.data.data.subjects[params.subjectid - 1].subjectDesc
                    );
                }
            } catch (err) {
                console.log(err);
            }
        };

        getSubject();
    }, [params.courseid, params.subjectid]);

    return subjectName;
};

export default useSubjectName;
